import { useMemo } from 'react'
import { useAdminAllChurchRequests } from '../../hooks/useAdmin'
import { DataTable } from '../../components/admin/DataTable'
import type { ColumnDef } from '@tanstack/react-table'
import type { AdminChurchRequest } from '../../types/admin'

function fmt(iso: string) {
  return new Date(iso).toLocaleString('en-US', {
    month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit',
  })
}

const columns: ColumnDef<AdminChurchRequest, unknown>[] = [
  {
    accessorKey: 'churchName',
    header: 'Church name',
    meta: { label: 'Church name' },
    cell: ({ getValue }) => <span className="font-medium">{getValue() as string}</span>,
  },
  {
    accessorKey: 'websiteUrl',
    header: 'Website',
    meta: { label: 'Website' },
    cell: ({ getValue }) => {
      const url = getValue() as string | null
      return url ? (
        <a href={url} target="_blank" rel="noopener noreferrer" className="text-primary no-underline hover:underline break-all text-[12px]">
          {url}
        </a>
      ) : <span className="text-muted">—</span>
    },
  },
  {
    accessorKey: 'createdAt',
    header: 'Requested',
    meta: { label: 'Requested' },
    cell: ({ getValue }) => <span className="text-muted">{fmt(getValue() as string)}</span>,
    sortingFn: 'datetime',
  },
]

export default function AdminChurchRequestsPage() {
  const { data, isLoading } = useAdminAllChurchRequests()
  const requests = useMemo(() => data?.data ?? [], [data])

  return (
    <div>
      <div className="mb-6">
        <h1 className="m-0 text-[24px] font-bold">Church requests</h1>
        <p className="text-[13px] text-muted mt-2 m-0 max-w-[560px] leading-[1.5]">
          Churches users asked to have added to Fellowship. Use Scrape or Add church to onboard them.
        </p>
        {!isLoading && <div className="text-[13px] text-muted mt-1">{requests.length} requests</div>}
      </div>

      <DataTable
        columns={columns}
        data={requests}
        isLoading={isLoading}
        filterable
        exportable
        exportFilename="church-requests"
        emptyMessage="No church requests yet."
        pageSize={100}
      />
    </div>
  )
}
